import { jsx as e } from "react/jsx-runtime";

import { memo as r } from "react";

import { useField as o } from "formik";

import t from "@ui-components-3/ui/lib/utils/classNames";

import l from "@ui-components-3/ui/lib/components/FormControl";

import a from "@ui-components-3/ui/lib/components/Checkbox";

import m from "../../hooks/useFormikSchema/index.js";

const i = e => e.touched && e.error || "", n = (n, s = ((e, r) => e), p) => r((({label: r, schema: c, name: u, noFormControl: d, FormControlProps: f, InputComponent: h, getFieldError: b = i, helper: F, helperVariant: v, HelperProps: y, variant: k, fullWidth: x, disabled: C, multiple: E, type: w, className: N, ...P}) => {
    if ("production" !== process.env.NODE_ENV) {
        if (!d && !r) throw console.log({
            name: u,
            type: w,
            label: r,
            schema: c
        }), new Error("label prop must be set when noFormControl is false");
        "value" in P && console.warn("<FormikField /> does not need value passed explicitly. It is taken automatically from form context. Just pass correct name. Params:", {
            name: u,
            type: w,
            label: r,
            schema: c
        });
    }
    const V = h || n, {formattedLabel: g} = m(u, r || "", c), [j, H, I] = o({
        name: u,
        type: w,
        multiple: E
    }), W = b(H), D = e(V, {
        ...s({
            ...j,
            ...P,
            multiple: E,
            disabled: C,
            variant: W ? "error" : k
        }, I)
    });
    return d ? D : e(l, {
        ...p,
        ...f,
        label: g,
        helper: W ? (J = W, (e => e && "string" == typeof e && !(e = e.trim()).startsWith("Error:") ? `Error: ${e}` : e)(J)) : F,
        HelperProps: y,
        labelVariant: C && V === a ? "disabled" : "normal",
        helperVariant: W ? "error" : v,
        className: t(x ? "w-full" : void 0, N),
        children: D
    });
    var J;
}));

/* TODO: add error icon */ export { n as default };
//# sourceMappingURL=index.js.map
